// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"448":"3c56c443","844":"501c2bf9"}[chunkId] + ".js";
};